import React from 'react';
import { Modal, Backdrop, Fade, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width:"400px",
        borderRadius:"8px",
    },
}));

function PlanOptions({ open, description, handleClose }:any) {
    const classes = useStyles();
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition={true}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                        <h2 
                        style={{fontSize:"28px"}}
                        id="transition-modal-title">Plan Descriptions</h2>
                        <Button
                        style={{minWidth:"auto",height:"20px",marginTop:"8px",width:"20px"}} onClick={handleClose}>
                        <CloseIcon />
                        </Button>
                        </div>

                        {description.map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    {item}
                                </div>
                            )
                        })}
                        
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default PlanOptions;



// WEBPACK FOOTER //
// ./src/shared/components/PlanOptions/index.tsx